"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.I18nPreferencesACSConfigClientProvider = exports.I18nPreferencesACSConfigContext = void 0;
var I18nPreferencesACSConfigContext_1 = require("./I18nPreferencesACSConfigContext");
Object.defineProperty(exports, "I18nPreferencesACSConfigContext", { enumerable: true, get: function () { return __importDefault(I18nPreferencesACSConfigContext_1).default; } });
var I18nPreferencesACSConfigClientProvider_1 = require("./I18nPreferencesACSConfigClientProvider");
Object.defineProperty(exports, "I18nPreferencesACSConfigClientProvider", { enumerable: true, get: function () { return __importDefault(I18nPreferencesACSConfigClientProvider_1).default; } });
